import { InternalBanks } from '../../interfaces/bankAccount'
import { ClientInfoStatus } from '../../interfaces/client'
import { FboBankAccountStatus } from '../../interfaces/fboBankAccount'
import { FilterFieldType, IFilter } from './types'

/** Clients the Bank Accounts client dropdown offers. */
export const FBO_BANK_ACCOUNT_CLIENT_STATUSES = [
  ClientInfoStatus.Current,
  ClientInfoStatus.DueDiligence,
]

export const FBO_BANK_ACCOUNTS_LIST_FILTERS_CONFIG = [
  {
    field: 'lastFour',
    dbField: 'account_number_last4',
    alias: 'bankAccountInfo',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Account #',
  },
  {
    field: 'collectionsAccountNumber',
    dbField: 'collections_account_number',
    alias: 'bankAccountInfo',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Collections #',
  },
  {
    field: 'clientName',
    dbField: 'client_name',
    alias: 'bankAccountInfo',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Client',
  },
  {
    field: 'lockbox',
    dbField: 'lockbox',
    alias: 'clientInfo',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Lockbox',
  },
  {
    field: 'bankName',
    dbField: 'bank_name',
    alias: 'bankAccountInfo',
    type: FilterFieldType.List,
    isSortable: true,
    title: 'Bank',
    options: Object.values(InternalBanks).map((bank) => ({ value: bank, label: bank })),
  },
  {
    // Derived from closed_at, so ListFboBankAccounts applies it itself.
    field: 'status',
    dbField: 'closed_at',
    alias: 'bankAccountInfo',
    type: FilterFieldType.List,
    isCustom: true,
    title: 'Status',
    options: Object.values(FboBankAccountStatus).map((status) => ({
      value: status,
      label: status,
    })),
  },
  {
    field: 'action',
    type: FilterFieldType.Empty,
    title: 'Action',
    align: 'right',
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    quickFilters: [
      { title: 'Active', filters: { status: FboBankAccountStatus.Active } },
      { title: 'Closed', filters: { status: FboBankAccountStatus.Closed } },
      { title: 'All', filters: {} },
    ],
  },
] as const satisfies IFilter[]
